import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";

// Reusable ag-Grid wrapper: modules, theme, default column behaviour, side bar, status bar,
// pagination and export helpers are configured here once.
//
// Usage:
//   <AgGridComponent ref={(grid) => this.grid = grid} columnDefs={columnDefs} rowData={rowData} />
//   this.grid.exportExcel("File_Name");   this.grid.exportCsv("File_Name");
//
// Any other ag-Grid prop (onCellClicked, rowSelection, frameworkComponents, ...) is passed straight through.
export default class AgGridComponent extends Component {

	onGridReady = (params) => {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		if (this.props.onGridReady) {
			this.props.onGridReady(params);
		}
	}

	getGridApi = () => {
		return this.gridApi;
	}

	getGridColumnApi = () => {
		return this.gridColumnApi;
	}

	exportExcel = (fileName, sheetName) => {
		this.gridApi.exportDataAsExcel({ fileName: fileName + ".xlsx", sheetName: sheetName || "Sheet1" });
	}

	exportCsv = (fileName) => {
		this.gridApi.exportDataAsCsv({ fileName: fileName + ".csv" });
	}

	getSideBar = () => {
		if (!this.props.showSideBar) {
			return false;
		}
		return {
			toolPanels: [
				{ id: "columns", labelDefault: "Columns", labelKey: "columns", iconKey: "columns", toolPanel: "agColumnsToolPanel" },
				{ id: "filters", labelDefault: "Filters", labelKey: "filters", iconKey: "filter", toolPanel: "agFiltersToolPanel" }
			]
		};
	}

	getStatusBar = () => {
		if (!this.props.showStatusBar) {
			return undefined;
		}
		return {
			statusPanels: [
				{ statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" }
			]
		};
	}

	render() {
		// Props handled by this wrapper; everything else goes to ag-Grid unchanged
		var { height, width, showSideBar, showStatusBar, pageSize, defaultColDef, onGridReady, ...gridProps } = this.props;

		return (
			<div style={{ height: height, width: width }} className="ag-theme-balham">
				<AgGridReact
					modules={AllModules}
					defaultColDef={Object.assign({ sortable: true, filter: true, resizable: true }, defaultColDef)}
					sideBar={this.getSideBar()}
					statusBar={this.getStatusBar()}
					pagination={pageSize > 0}
					paginationPageSize={pageSize}
					onGridReady={this.onGridReady}
					{...gridProps}
				/>
			</div>
		);
	}
}

AgGridComponent.defaultProps = {
	height: "580px",
	width: "100%",
	showSideBar: true,
	showStatusBar: true,
	pageSize: 50
};
